import React from 'react'
import { Datagrid, TextField } from 'react-admin'
import DeleteAndExportBulk from 'ui-shared/BulkActionGroups/DeleteAndExportBulk'
import KFilters from 'ui-shared/KFilters'
import KPagination from 'ui-shared/KPagination'
import KList from 'ui-shared/KWrappers/KList'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import { BaseListProps } from 'ui-shared/WrappedInputs/CatalogItemBaseList'

const KampaayerList: React.FC<BaseListProps> = (props) => {
  return (
    <SectionWrapper>
      <KList
        {...props}
        exporter={false}
        pagination={<KPagination />}
        perPage={40}
        sort={{ field: 'lastName', order: 'ASC' }}
        filters={<KFilters />}
      >
        <Datagrid rowClick="edit" bulkActionButtons={<DeleteAndExportBulk />}>
          <TextField source="firstName" sortable={false} />
          <TextField source="lastName" />
          <TextField source="email" sortable={false} />
          <TextField source="phone" sortable={false} />
        </Datagrid>
      </KList>
    </SectionWrapper>
  )
}

export default KampaayerList
